import React from "react";
import Iconfont from "@components/iconfont/iconfont";

export default function H5FormError({ error }) {
  if (!error) return null;

  return (
    <span className="h5-login-form-error">
      <Iconfont
        className="h5-login-form-error-icon"
        type="icon-a-gantanhaoxi"
      />
      <span className="h5-login-form-error-text">{error}</span>
    </span>
  );
}
